import React, { FC } from 'react'
import { GridColDef } from '@mui/x-data-grid-premium'
import { GatewayColumnsDataGrid } from 'src/components/columns/gateway'
import { Gateway, GatewayState } from 'src/api'
import { CommonGatewayList } from './commonGatewaysList'
import { GatewayContextMenu, GatewayMenuItemKey, useGatewayContextMenu, createActionsColumn } from './gatewayContextMenu'

interface AvailableGatewayListProps {
  isLoading: boolean
  count: number
  data: Gateway[]
  states: GatewayState[]
  refetchGatewayList: () => void
}

export const AvailableGatewayList: FC<AvailableGatewayListProps> = ({ data, isLoading, count, states, refetchGatewayList }) => {
  const { currentRow, menuAnchorEl, handleOpenMenu, handleCloseMenu } = useGatewayContextMenu()

  const columns: GridColDef<Gateway>[] = [
    GatewayColumnsDataGrid.DeviceId,
    GatewayColumnsDataGrid.IMEI,
    GatewayColumnsDataGrid.DevEUI,
    GatewayColumnsDataGrid.ExternalDeviceId,
    GatewayColumnsDataGrid.OnlineStatus,
    GatewayColumnsDataGrid.LastPingAt,
    GatewayColumnsDataGrid.Name,
    GatewayColumnsDataGrid.CreatedAt,
    createActionsColumn(handleOpenMenu)
  ]

  return (
    <>
      <CommonGatewayList columns={columns} count={count} data={data} isLoading={isLoading} />
      <GatewayContextMenu
        menuItems={[GatewayMenuItemKey.Assign]}
        currentRow={currentRow}
        menuAnchorEl={menuAnchorEl}
        onOpenMenu={handleOpenMenu}
        onCloseMenu={handleCloseMenu}
        states={states}
        refetchGatewayList={refetchGatewayList}
      />
    </>
  )
}
